import { useCallback } from 'react';

import { VOID_FUNCTION } from 'constants/index';
import { getChangeEvent } from 'components/modules/Insurance/Insurance.helpers';
import { dadataAddressToState } from 'store/anketa/mappers/abstractAddress';

import { ADDRESS_HANDLER_KEYS } from '../../Policyholder.constants';

export const useAddressInputPresenter = ({ name, onChange: onChangeProp = VOID_FUNCTION }) => {
  const onChange = useCallback(
    (event) => {
      const { value } = getChangeEvent(event);

      let address = value;
      let daData;
      let postalCode;

      if (typeof value !== 'string') {
        const { data, value: daDataAddress } = value;
        const { postal_code: daDataPostalCode } = data ?? {};

        address = daDataAddress;
        daData = dadataAddressToState(data);
        postalCode = daDataPostalCode;
      }

      const payload = {
        [ADDRESS_HANDLER_KEYS.ADDRESS]: address,
        [ADDRESS_HANDLER_KEYS.DA_DATA]: daData,
        [ADDRESS_HANDLER_KEYS.POSTAL_CODE]: postalCode,
      };

      onChangeProp(name ? { [name]: payload } : payload);
    },
    [onChangeProp, name]
  );

  return { onChange };
};
